import { createStyles, makeStyles } from '@mui/styles'

export const useStyles = makeStyles(
    createStyles({
        container: {
            padding: 18,
            border: '1px solid #E5E5E5',
            borderTop: 'none',
            borderRadius: 8,
            background: '#FFF',
            boxShadow: '0px 2px 12px rgba(0, 0, 0, 0.12), inset 0 30px 0 -27px rgba(0, 75, 177, 0.7)'
        }
    })
)
